module.exports = __webpack_public_path__ + "static/media/help.87296432.svg";